import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./testimonials.scss";

// Custom wrap function to cycle through testimonials
function wrap(min: number, max: number, value: number): number {
    const range = max - min;
    return ((value - min) % range + range) % range + min;
}

export const Testimonial = () => {
    const testimonials = [
        {
            text: "During my long association with Taxmann spanning over 25 years, I have been regularly referring to Taxmann publication’s books and journals for my professional work. I find online resources available in Taxmann portal very comprehensive as it displays real-time updates on tax news, circulars, notifications and amendments to various fiscal regulations. Also, the Taxmann portal facilitates browsing of various Acts and Rules at the click of a mouse and provides easy access to vast database of analytical articles adding value to my professional works and research efforts with accuracy, efficiency, and quality.",
            name: "Mr. Gangadhar Panda",
            designation: "CIT (OSD), FATF Cell, Dept. of Revenue, Ministry of Finance",
            image: "https://cdn.taxmann.com/taxmann-assets/images/gangadhar_panda_p.png",
        },
        {
            text: "My association with Taxmann is more than 20 years old now. The Taxmann website, apart from giving the latest news, circulars and notifications relevant for professionals, also serves as a “Knowledge Portal”, and is an excellent source of information. It includes analytical articles and updates on diverse subjects... They have the largest online database on taxation including direct tax, indirect tax and international taxation. The online research platform is very useful and enable us in tax planning activities. Taxmann App and Taxmann Twitter account is an indispensable tool for practicing professionals as well as those in the industry.",
            name: "CA. Amit Rustagi",
            designation: "Group Head Taxation, Security and Intelligence Services India Limited",
            image: "https://cdn.taxmann.com/taxmann-assets/images/amit_rustagi_p.png",
        },
        {
            text: "Taxmann is a robust repository of knowledge which is very user friendly and my first and last resort for any research. Articles, commentaries and latest decision alerts are the USPs of Taxmann. The section wise digest and master guide make it a whole code from an amateur to a leading lawyer.",
            name: "CA. Pankaj Shah",
            designation: "Ex Chairman, ICAI, Indore and Partner - G. J. Shah &amp; Co.",
            image: "https://cdn.taxmann.com/taxmann-assets/images/capankaj_p.png",
        },


        {
            text: "Taxmann has been amazing in there service to academics especially to Jagran Lakecity University - School of Law. Their products are comprehensive and cover various aspects of law for the better interest of students. Promptness in their service and outstanding support in carrying out academic and extracurricular activities like moots, conferences and symposium puts it among the top publishers in the arena and definitely for the betterment of academics in the society",
            name: "Prof.(Dr.) Yogendra Kumar Srivastava",
            designation: "Director, JLU School of Law, Bhopal",
            image: "https://cdn.taxmann.com/taxmann-assets/images/prof_yogendra_p.png",
        },

        {
            text: '"Taxmann Publications" content is best and most knowledgeable. The material in the field of Direct and Indirect taxes, Corporate laws, International taxation etc. is available for both students and practitioners through acts, referencers and much more. We use it in our day to day practice.',
            name: "CA. Sukesh Choradiya",
            designation: "Secretary, CIRC of ICAI, Jabalpur",
            image: "https://cdn.taxmann.com/taxmann-assets/images/sukesh_p.png",
        },



        {
            text: "Participating in Taxmann's Masterclass was a truly enriching experience. The session was expertly designed, offering deep insights and practical knowledge that I can immediately apply in my field. The speakers were highly knowledgeable, engaging, and approachable, making complex topics easy to understand. I feel more confident in my skills and am inspired to continue learning. I highly recommend Taxmann's learning initiatives to anyone looking to enhance their professional growth. Thank you for such an impactful session!",
            name: "Bharath Kumar Parasmal Jain",
            designation: "Partner | BO & Co LLP",
            image: "https://cdn.taxmann.com/taxmann-assets/images/testi-bharath-kumar-parasmal-jain.png",
        },
        {
            text: "Thank you very much, Taxmann, for your online webinars and workshops. The webinars are very useful and full of content and knowledge. The faculty members are very resourceful and experienced. Please keep up the excellent work.",
            name: "M.S. Jagan Kumar",
            designation: "Chartered Accountant | M.S. Jagan Kumar & Associates",
            image: "https://cdn.taxmann.com/taxmann-assets/images/testi_m_s_jagan_kumar.png",
        },
        {
            text: "Taxmann's Webinars and Workshops are simply fantastic because the subjects chosen for the webinars or workshops are always contemporary, and the discussions are detailed with interesting interpretations, analyses, and relevant case laws, making every session informative and unique compared to other institutions conducting similar webinars. Making the webinars free and providing recordings demonstrate Taxmann's true endeavour to spread legal and taxation awareness to the general public and to enhance the expertise of professionals like me.",
            name: "CA. S.I. Sreedharan",
            designation: "Director (Retired) | RMD Kwikform India Private Limited",
            image: "https://cdn.taxmann.com/taxmann-assets/images/testi_ca_s_i_sreedharan.png",
        },
        {
            text: "I have been using various Taxmann products for over three decades. The recently introduced webinars have added immense value to the reservoir of cutting-edge legal knowledge. One-to-one interactions and Q&A sessions help participants directly obtain solutions to problems from learned faculty experts in various fields. All these resources have immensely helped me stay updated in my core area of practice over the years. A big thank you to Taxmann and all the best for future endeavours like AI.",
            name: "Deepak Chintaman Gadgil",
            designation: "Practising Chartered Accountant",
            image: "https://cdn.taxmann.com/taxmann-assets/images/testi_deepak_chintaman_gadgil.png",
        },


    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState<1 | -1>(1);

    function changeSlide(newDirection: 1 | -1) {
        setDirection(newDirection);
        setCurrentIndex((prev) => wrap(0, testimonials.length, prev + newDirection));
    }

    return (
        <div className="testimonial section-screens">
            <div className="testimonial_header">
            <div>
                <h2 className="testimonial__title">
                    The Words of Those Who Trust <br />
                    <span className="green">Research</span> |{" "}
                    <span className="blue">Practice</span> |{" "}
                    <span className="teal">Learning</span>.
                </h2>
            </div>
            <div className="testimonial_arrows m-none">
                <span className="arrow_right cursor-pointer"  onClick={() => changeSlide(-1)}>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3776 5.77972L12.1409 15.0164C11.0501 16.1072 11.0501 17.8922 12.1409 18.9831L21.3776 28.2197" stroke="#110D3F" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                </span>
                <span className="arrow_left cursor-pointer" onClick={() => changeSlide(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                            <path d="M12.623 28.2193L21.8597 18.9826C22.9505 17.8918 22.9505 16.1068 21.8597 15.016L12.623 5.7793" stroke="#110D3F" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </span>
            </div>

      </div>

      <motion.div 
    initial={{ y: -50, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    transition={{ type: "spring", stiffness: 300, damping: 80 }}
    viewport={{once:true, amount: 0.3 }}  className="testimonial__slider">               

                {/* Testimonial Animation */}
                <AnimatePresence initial={false} custom={direction} mode="popLayout">
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0, x: direction * 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: direction * -100 }}
                        transition={{ type: "spring", stiffness: 300, damping: 30 }}
                        className="testimonial-details"
                    >
                     

<div className="testimonial-contents testimonial__quote"> 
<div className="testimonial-items"> 
<div className="testimonial-item-content">{testimonials[currentIndex].text}  </div>
<div className="testimonial-item-footer"> 
  <span className="testimonial-name"> {testimonials[currentIndex].name} </span>
  <span className="testimonial-desination">  {testimonials[currentIndex].designation} </span>
   </div>
   <span className="testimonial-photos"> 
   <img
                                src={testimonials[currentIndex].image}
                                alt={testimonials[currentIndex].name}
                                className="testimonial-photo"
                            />
   </span>
</div>

</div>                 

                    </motion.div>
                </AnimatePresence>
                
               
            </motion.div>


            <div className="testimonial_arrows l-flex-none">
            <span
  className={`arrow_right cursor-pointer ${currentIndex === 0 ? 'disabled-arrow' : ''}`}
  onClick={() => {
    if (currentIndex > 0) changeSlide(-1);
  }}
>
<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3776 5.77972L12.1409 15.0164C11.0501 16.1072 11.0501 17.8922 12.1409 18.9831L21.3776 28.2197" stroke="#110D3F" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                </span>
                <span className="arrow_left cursor-pointer" onClick={() => changeSlide(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                            <path d="M12.623 28.2193L21.8597 18.9826C22.9505 17.8918 22.9505 16.1068 21.8597 15.016L12.623 5.7793" stroke="#110D3F" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </span>
            </div>
        </div>
    );
};
